/* istanbul ignore file */
import { Routes } from 'react-router-dom';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { LeadRouter } from 'domain/sales/lead';
import { AccountRouter } from 'domain/sales/account';
import { ContactRouter } from 'domain/sales/contact';
import { OpportunityRouter } from 'domain/sales/opportunity';
import { ProjectsDashboardRouter } from 'domain/sales/projectsDashboard';
import { Router, Route } from 'framework/routing';
import UnlinkedCrmEmailActivitiesRouter from 'domain/sales/unlinkedEmails/UnlinkedCrmEmailActivitiesRouter';
import LeadReportRouter from 'domain/sales/report/LeadReportRouter';

const SALES_PATH = '/crm';

const SalesRouter: Router = () => {
  const { isAuthenticated } = useAuthenticationService();

  return (
    <Routes>
      <Route path={LeadRouter.getRouterPath()} element={<LeadRouter />} />
      <Route path={LeadReportRouter.getRouterPath()} element={<LeadReportRouter />} />
      <Route path={AccountRouter.getRouterPath()} element={<AccountRouter />} />
      <Route path={ContactRouter.getRouterPath()} element={<ContactRouter />} />
      <Route path={OpportunityRouter.getRouterPath()} element={<OpportunityRouter />} />
      <Route path={ProjectsDashboardRouter.getRouterPath()} element={<ProjectsDashboardRouter />} />
      <Route path={UnlinkedCrmEmailActivitiesRouter.getRouterPath()} element={<UnlinkedCrmEmailActivitiesRouter />} />
      <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
    </Routes>
  );
};

SalesRouter.getRouterPath = () => `${SALES_PATH}/*`;

export default SalesRouter;
